import React from 'react';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn, faTerminal, faQuidditch } from '@fortawesome/free-solid-svg-icons';

import './ycAboutUs.scss';

export const YcAboutUs = withTranslation(['home'])(
  class YcAboutUsClass extends React.PureComponent {
    blocks = [
      {
        title: 'home.about-us.conseil.title',
        icon: <FontAwesomeIcon icon={faBullhorn} className="icon" />,
        description: 'home.about-us.conseil.description',
        active: true,
        colors: ['#9C67FF', '#47ABFF']
      },
      {
        title: 'home.about-us.design.title',
        icon: <FontAwesomeIcon icon={faQuidditch} className="icon" />,
        description: 'home.about-us.design.description',
        active: false,
        colors: ['#FF7777', '#FF7BFA']
      },
      {
        title: 'home.about-us.web.title',
        icon: <FontAwesomeIcon icon={faTerminal} className="icon" />,
        description: 'home.about-us.web.description',
        active: false,
        colors: ['#47D5FF', '#50E3C2']
      },
    ];

    render() {
      const { t } = this.props;
      return (
        <div className="yc-about-us">
          <div className="content">
            <div className="row">
              {this.blocks.map((b, index) => (
                <div className="block col-xs-10 col-md-4" key={index}>
                  <div className="title">
                    <div
                      style={{ background: `transparent linear-gradient(207deg, ${b.colors[0]} 0%, ${b.colors[1]} 100%) 0% 0% no-repeat padding-box ` }}
                      className="icon-bg"
                    >
                      {b.icon}
                    </div>
                    <h3 dangerouslySetInnerHTML={{ __html: t(b.title) }}></h3>
                  </div>
                  <p dangerouslySetInnerHTML={{ __html: t(b.description) }}></p>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
  },
);
